import React from "react";
import { tokens } from "../../theme/theme";
import { Typography, Card, CardContent, Grid, Button, useTheme, Box, } from "@mui/material";

import { useTranslation } from "react-i18next";
import DashboardCard from "../../components/common/DashboardCard";
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
const TransactionMenu = ({ SetActive, handleBackDashboard }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();

    const callback = () => {
        handleBackDashboard();
    };

    return (
        <Box >           

            <Card sx={{ backgroundColor: "transparent", borderRadius: "0px", height: "48px" }}>
                <CardContent>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography variant="h5" color={colors.grey[100]} fontWeight="bold" justifyContent="center">Transaction Management </Typography>
                    </Box>
                </CardContent>
            </Card>

          
            <Box p={2}>

                <Grid container spacing={2} justifyContent="start" marginTop="10px"  >

                    <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                        <DashboardCard
                            title="Order Mapping (New CO No)" //{t('master.party_master')}
                            icon={<ShoppingCartCheckoutIcon fontSize="large" color="secondary" />}
                            onClick={() => SetActive("Order Mapping")}
                            subtitle="View"
                        />
                    </Grid>

                    {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                           
                            <Typography variant="h6" mt={2}>Order Selection</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("Order Selection")}>Select</Button>
                        </Card>
                    </Grid>
 
 
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                           
                            <Typography variant="h6" mt={2}>Deckle Matching</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("Deckle Matching")}>Match</Button>
                        </Card>
                    </Grid>
 
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card sx={{ backgroundColor: colors.primary[400], p: 2, borderRadius: 2, textAlign: "center" }}>
                         
                            <Typography variant="h6" mt={2}>Short Close Orders</Typography>
                            <Button variant="contained" color="secondary" sx={{ mt: 2 }} onClick={() => SetActive("Short Close")}>Update</Button>
                        </Card>
                    </Grid> */}


                </Grid>
            </Box>
        </Box>

    )
}
export default TransactionMenu;